module.exports = __webpack_public_path__ + "static/media/covid_full.090f041c.JPG";